export default __webpack_public_path__ + "square.svg";